import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient from "../../../api/collection";

const useSendCollectionCodeEmailMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ codeId, email }: { codeId: string; email: string }) =>
      collectionApiClient.sendCollectionCodeEmail(codeId, email),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["collection-codes"] });
    },
  });
};

export default useSendCollectionCodeEmailMutation;
